export default "__VITE_ASSET__B4i4NTbA__ 100w";